import { FC, useState, useEffect } from 'react';
import { Grid } from '@mui/material';
import CustomTable from '../../components/common/CustomTable/CustomTable';
import { useModelVehicleStore } from '../../hooks/useModelVehicleStore';
import { ModelVehicle } from '../../types/slices/modelVehicleType';
import { ModalConfirm } from '../../components/common/ModalConfirm/ModalConfirm';
import { useNavigate } from 'react-router-dom';
import { RoutesMap } from '../../types';
import { selectHeaderState } from '../../redux/slices/headerSlice';
import { useSelector } from 'react-redux';
import { useModelMaintenance } from '../../hooks/useModelMaintenance';
import { ApiStatus } from '../../types/api/status';

const columns = [
    { type: "options", field: "options", label: "OPCIONES", align: 'center' },
    { type: "text", field: "name", label: "NOMBRE", align: 'center' },
    { type: 'detail', field: 'detail', label: 'MANTENCIONES', align: 'center' },
    { type: "text", field: "", label: "", align: 'center' },
]

export const ModelVehicleList: FC<any> = () => {
    const navigate = useNavigate();
    const { search } = useSelector(selectHeaderState);
    const [loading, setLoading] = useState<boolean>(false);
    const [page, setPage] = useState<number>(0);
    const [rowsPerPage, setRowsPerPage] = useState<number>(10);
    const [rowSelected, setRowSelected] = useState<ModelVehicle>(
        {} as ModelVehicle
    );
    const [modalDeleteConfirm, setModalDeleteConfirm] =
        useState<boolean>(false);

    const { modelVehicles, modelVehicleStatus, getModelVehicles, setSelectedModelVehicle, deleteModelVehicleStore } = useModelVehicleStore();
    const { deleteStateModelMaintenance } = useModelMaintenance();

    useEffect(() => {
        getModelVehiclesApi();
    }, [search]);

    const getModelVehiclesApi = async () => {
        try {
            setLoading(true);
            let payload: any = {}
            if (search !== '') {
                payload = {
                    search
                }
            }
            await getModelVehicles(payload);
            deleteStateModelMaintenance();
            setLoading(false);
        } catch (error) {
            setLoading(false);
        }
    };

    const onAdd = () => {
        navigate({ pathname: RoutesMap.MODEL_VEHICLES_FORM });
    };

    const onEdit = (rowSelected) => {
        setSelectedModelVehicle(rowSelected);
        navigate({ pathname: RoutesMap.MODEL_VEHICLES_FORM });
    };

    const onDelete = (rowSelected) => {
        setRowSelected(rowSelected);
        setModalDeleteConfirm(true);
    };

    const onDeleteConfirm = async () => {
        const response = await deleteModelVehicleStore(rowSelected.id);
        if (response === true) {
            setSelectedModelVehicle({} as ModelVehicle);
            setModalDeleteConfirm(false);
            getModelVehiclesApi();
        }
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    const onDetail = (rowSelected) => {
        setSelectedModelVehicle(rowSelected);
        navigate({ pathname: RoutesMap.MAINTENANCE_MODEL_FORM });
    }

    return (
        <>
            <Grid container xs={12}>
                <CustomTable
                    title={'Modelo de Vehículos'}
                    columns={columns}
                    loading={loading}
                    rows={modelVehicles || []}
                    onRowClick={() => { }}
                    hasOptions
                    onAddFn={onAdd}
                    onDelete={onDelete}
                    onEdit={onEdit}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    handleChangePage={handleChangePage}
                    handleChangeRowsPerPage={handleChangeRowsPerPage}
                    onDetailMaintenance={onDetail}
                />
            </Grid>
            {modalDeleteConfirm && (
                <ModalConfirm
                    open={modalDeleteConfirm}
                    closeModal={() => {
                        setModalDeleteConfirm(false);
                    }}
                    onCancel={() => {
                        setModalDeleteConfirm(false);
                    }}
                    onConfirm={onDeleteConfirm}
                    status2={modelVehicleStatus === ApiStatus.FETCHING ? true : false}
                />
            )}
        </>
    )
}
